{
  "terms-of-service": "Terms Of Service",
  "read-terms-of-service": "Please, take a few minutes to read over our Terms Of Service.",
  "agree-terms-of-service": "I have read and agree to the terms of service",
  "add-license": "Add License",
  "welcome": "Welcome to the Championship Title Experience",
  "excited": "We're excited to have you with us.",
  "thanks": "Thanks for taking a few moments to set up your profile.",
  "go-to-profile": "Go to my profile",
  "basic-information": "Basic Information",
  "error": "Error updating data",
  "proceed": "Proceed",
  "terms-item-one": "1. Acceptance of Terms and Platform Overview",
  "terms-item-two": "2. Not a Substitute for Legal Counsel",
  "terms-item-three": "3. User Responsibilities and Acceptable Use",
  "terms-item-four": "4. Confidentiality and Data Security",
  "terms-item-five": "5. Liability Limitations and Disclaimers",
  "terms-item-six": "6. Intellectual Property Rights",
  "terms-item-seven": "7. User Accounts, Authentication, and Access Controls",
  "terms-item-eight": "8. Dispute Resolution and Governing Law",
  "terms-item-nine": "9. Modifications to Terms of Service",
  "terms-item-ten": "10. Termination of Service",
  "terms-item-eleven": "11. Mandatory Disclosures for Texas Real Estate Title Services",
  "terms-item-twelve": "12. Contact and Support",
  "terms-item-thirteen": "13. Severability",
  "terms-item-fourteen": "14. Entire Agreement",
  "proceed-disclaimer": "By clicking \"Proceed\" or accessing the Platform, you acknowledge that you have read these Terms of Service, understand them, and agree to be bound by them."
}
